/* Focus style for input or container of inputs (like multiselect) */
// export const FOCUS_WITHIN_CLASS_NAME = `outline-hidden focus-within:rounded-sm focus-within:border-sky-300 focus-within:ring-4 focus-within:ring-sky-500/20`;
export const FOCUS_WITHIN_OLD_CLASS_NAME = `focus-within:rounded-sm focus-within:outline-3 focus-within:outline-sky-500/20`;

export const FOCUS_CLASS_NAME = `focus:outline-3 focus:outline-sky-500/20 focus:rounded-sm`;
export const FOCUS_VISIBLE_CLASS_NAME = `focus-visible:outline-1 focus-visible:outline-blue-300 focus-visible:ring-4 focus-visible:ring-[#0086C93D]`;
export const FOCUS_VISIBLE_LINK_CLASS_NAME = `focus-visible:outline-offset-4 focus-visible:ring-offset-4 rounded-md`;

export const FOCUS_WITHIN_CLASS_NAME = `focus-within:outline-1 focus-within:outline-blue-300 focus-within:ring-4 focus-within:ring-[#0086C93D]`;
export const FOCUS_WITHIN_LINK_CLASS_NAME = `focus-within:outline-offset-4 focus-within:ring-offset-4 rounded-md`;

export const FOCUS_INPUT_CLASS_NAME = `outline-hidden focus:border-blue-300 focus:ring-4 focus:ring-[#0086C93D]`;
export const FOCUS_VISIBLE_BUTTON_CLASS_NAME = `outline-hidden focus-visible:border-blue-300 focus-visible:ring-4 focus-visible:ring-[#0086C93D]`;

export const SECTION_CLASS_NAME =
  "border-athensgray-100 relative space-y-4 rounded-md border bg-white p-4";

export const SCROLLBAR_CLASS_NAME =
  "[&::-webkit-scrollbar]:w-[13px] [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-[#EAECF0] [&::-webkit-scrollbar-thumb]:border-3 [&::-webkit-scrollbar-thumb]:border-white [&::-webkit-scrollbar-thumb]:bg-clip-padding";

// TODO: StopFinder and MultiSelect should use the same combo box component maye.
export const LIST_RESULTS_CLASS_NAME = `w-full absolute z-10 mt-2 max-h-[255px] overflow-auto rounded-md border border-[#D0D5DD] bg-white shadow-sm ${SCROLLBAR_CLASS_NAME}`;

export type Instance = "dev" | "prod" | "stag";
export const INSTANCE: Instance =
  (process.env.NEXT_PUBLIC_INSTANCE as Instance) || "prod";

/* Local/Session Storage key */
// General config keys
export const LS_TENANT_KEY = "moco3.config";
export const LS_LANGUAGE_KEY = "moco3.language";

// Dashboard specific keys

export const LS_DASHBOARD_MAP_PREFIX = "moco3.dashboard.map";
export const LS_DASHBOARD_MAP_FILTER = `${LS_DASHBOARD_MAP_PREFIX}.filter`;
export const LS_DASHBOARD_MAP_PERMALINK = `${LS_DASHBOARD_MAP_PREFIX}.permalink`;
export const LS_DASHBOARD_TIMELINE_PREFIX = "moco3.dashboard.timeline";
export const LS_TIMELINE_FILTER_KEY = `${LS_DASHBOARD_TIMELINE_PREFIX}.filter`;

// Notifications list specific keys
export const LS_SITUATIONS_LIST_PREFIX = "moco3.situations";
export const LS_FILTER_PERSIST_KEY = `${LS_SITUATIONS_LIST_PREFIX}.filter`;
export const LS_SORT_PERSIST_KEY = `${LS_SITUATIONS_LIST_PREFIX}.sort`;
export const LS_ACTIVE_PAGE_PERSIST_KEY = `${LS_SITUATIONS_LIST_PREFIX}.activepage`;

// Notification form specific keys
export const LS_SITUATION_FORM_PREFIX = "moco3.situation";
export const LS_SITUATION_PREVIEW_KEY = `${LS_SITUATION_FORM_PREFIX}.preview.map.permalink`;

// Cypress testing keys
export const LS_TOKEN_KEY = "moco3.token";

export const TEXT_SIZES = ["Small", "Medium", "Large"] as const;
export enum TextSize {
  Large = "Large",
  Medium = "Medium",
  Small = "Small",
}

export const textualContentCategories = [
  "description",
  "consequence",
  "recommendation",
  "remark",
  "reason",
  "summary",
];
